module.exports = __webpack_public_path__ + "img/pic_pc.7444a17f.svg";